/**
 * One inbox, one cache entry.
 *
 * The bell polled `/v1/notifications` on a raw setInterval outside the query
 * cache while the notifications screen fetched the same endpoint through
 * useQuery — two poll loops over one inbox, disagreeing about the unread count
 * the moment either of them wrote. The key and the row shape live here so both
 * read the same cached answer; the bell is in the eager bundle and the screen
 * is lazy, so neither can own the constant without dragging the other along.
 */
export const NOTIFICATIONS_KEY = '/v1/notifications?limit=100';

/** How often the inbox is re-read. React Query pauses the interval while the
 *  tab is in the background of its own accord, which the setInterval did not —
 *  the bell went on polling in a tab nobody had looked at for a day. */
export const NOTIFICATIONS_POLL_MS = 60_000;

export interface NotificationRow {
  id: string;
  kind: string;
  title: string;
  body: string;
  readAt: string | null;
  createdAt: string;
  /**
   * Whatever the writer attached. `operation_id` is the one the screen uses;
   * `operation_state` is added on the way out by the server so the row knows
   * whether the task is still waiting on the reader.
   */
  payload?: Record<string, unknown> | null;
}

export interface Inbox {
  items: NotificationRow[];
  unread: number;
}
